module.exports = __webpack_public_path__ + "img/three1Red.b0d802f6.png";